import React, { Component } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import GroupContainer from 'Components/AWLMultiMode/GroupContainer';
import ClassNames from 'classnames';
import Overlay from 'Components/Overlay';
import Heading from 'Components/Heading';
import Moment from 'moment';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import { formatToINR } from 'Utils/transform';

const TRIP_TYPE = "trip";

class DisposalProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trips: props.trips || [],
            tripDetails: []
        }
    }

    toggleAllLegTransporters = (group) => {
        const { selectedTransporters } = this.state;
        const isExist = selectedTransporters.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            selectedTransporters.splice(isExist, 1);
        } else {
            selectedTransporters.push(JSON.parse(JSON.stringify(group)));
        }
        this.setState({ selectedTransporters });
    }

    toggleTransporter = (transporter, group) => {
        const { selectedTransporters } = this.state;
        const transGroup = JSON.parse(JSON.stringify(group));
        const isExist = selectedTransporters.findIndex(trans => trans.id === group.id);
        if(isExist > -1) {
            const isTransporter = (selectedTransporters[isExist].transporters || []).findIndex(trans => trans.id === transporter.id);
            if(isTransporter > -1) {
                selectedTransporters[isExist].transporters.splice(isTransporter, 1);
            } else {
                selectedTransporters[isExist].transporters.push(JSON.parse(JSON.stringify(transporter)));
            }
        } else {
            transGroup.transporters = [];
            transGroup.transporters.push(transporter)
            selectedTransporters.push(transGroup);
        }
        this.setState({ selectedTransporters });
    }

    setTransport = () => {
        const { tripIndex, selectedTransporters, trips } = this.state;
        trips[tripIndex]['transporters'] = selectedTransporters;
        this.setState({ trips, tripIndex: '', showTransporters: false });
        this.props.onChangeProductTrips(trips);
    }

 
    render() {
        const { trips, showTransporters, selectedTransporters, tripDetails } = this.state;
        const { groups } = this.props;

        return (
            <div className="box-shadow col-1 pv-10 ph-5 mt-20">
                 <ResponsiveTable className="courier-table pt-10 ph-10 pb-80">
                    <table cellpadding="0" cellspacing="0" className="col-1">
                        <thead>
                           <tr>
                               <th>Sl No.</th>
                               <th>Zone</th>
                               <th>Depot Code</th>
                               <th>Depot Name</th>
                               <th>Price</th>
                               <th>Lifting Date</th>
                               <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(trips || []).map((trip, valIndex) => {
                            return(<>
                                <tr style={{'backgroundColor': '#d4f2ff'}}>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{valIndex + 1} <span className='theme-color curP fBold' onClick={() => {
                                        const { tripDetails } = this.state;
                                        if(tripDetails.includes(trip.trip_id)) {
                                            tripDetails.splice(tripDetails.indexOf(trip.trip_id), 1);
                                        } else {
                                            tripDetails.push(trip.trip_id)
                                        }
                                        this.setState({ tripDetails })
                                    }}>{!tripDetails.includes(trip.trip_id) ? '-' : '+'}</span></td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.zone}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.from}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.depo_name}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR(trip.total_price)}</td>
                                    
                                    <td  style={{ 'borderBottom': '1px solid grey'}}>
                                        <div className='dateRangePicker'>
                                        <DateRangePicker
                                            startDate={trip.contract_tenure_from ? Moment(trip.contract_tenure_from || null) : null}
                                            startDateId={`startDate_${trip.trip_id}`}
                                            endDate={trip.contract_tenure_to ? Moment(trip.contract_tenure_to) : null}
                                            endDateId={`endDate_${trip.trip_id}`}
                                            onDatesChange={({ startDate, endDate }) => {
                                                const { trips } = this.state;
                                                trips[valIndex].contract_tenure_from = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
                                                trips[valIndex].contract_tenure_to = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                                this.setState({
                                                    trips
                                                });
                                                this.props.onChangeProductTrips(trips);
                                            }}
                                            focusedInput={this.state[`focusedInput_${trip.trip_id}`]}
                                            onFocusChange={focusedInput => this.setState({ [`focusedInput_${trip.trip_id}`]: true ? focusedInput : null })}
                                            displayFormat={'DD MMM YYYY'}
                                            noBorder={true}
                                            minimumNights={0}
                                            />
                                        </div>
                                    </td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>
                                    <button className="border-theme ht-30 bg-white theme-color fBold fs-16 br-20 mt-5 mb-5 pl-15 pr-15" onClick={() => this.setState({ showTransporters: true, tripIndex: valIndex, selectedTransporters: trip['transporters'] && [...trip['transporters']] || []})}>{`Add Buyers ${(trip['transporters'] && trip['transporters'].length > 0) ? ` (${(trip.transporters || []).reduce((sum, item) => sum += (item.transporters || []).length, 0)}) ` : ''}`}</button>
                                    </td>
                                </tr>
                                {!tripDetails.includes(trip.trip_id) && 
                                <tr>
                                    <td colSpan={'7'}>
                                    <table cellpadding="0" cellspacing="0" className="col-1 mb-20">
                                        <thead>
                                        <tr>
                                            <th style={{'backgroundColor': '#486aa3'}}>Zone</th>
                                            {/* <th style={{'backgroundColor': '#486aa3'}}>Depo Code</th> */}
                                            <th style={{'backgroundColor': '#486aa3'}}width="200">Depot Name</th>
                                            {/* <th style={{'backgroundColor': '#486aa3'}}>Material Code</th> */}
                                            <th style={{'backgroundColor': '#486aa3'}} width="250">Material Desc.</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="80">Product Type</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">Quantity</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">UOM</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Base Rate (Excluding GST)</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Total MSP</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">LSP</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">SSP</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {(trip.sub_trip_disposal_product || []).map((subTrip, subTripIndex) => (
                                            <tr>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.zone}</td>
                                                {/* <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.from}</td> */}
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.depo_name}</td>
                                                {/* <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.to}</td> */}
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.material_code_description}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.product_type}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.quantity}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.pricing_basis_name}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR((subTrip.bidding_and_payments || {}).qbr)}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR(subTrip.quantity_cost)}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{'-'}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{'-'}</td>
                                            </tr>))}
                                        </tbody>
                                    </table>
                                    </td>
                                </tr>
                                }
                            </>)})}
                        </tbody>
                    </table>
                    {showTransporters && <Overlay>
                                <div className="z-100 box-shadow pf t-0 col-1 bg-white pv-10 ht-40 border-bottom-theme">
                                    <Heading 
                                        text={'Buyers'} 
                                        className="tCenter"/>
                                    {/* <CancelIcon onClick={this.setTransport} className="wt-15 ht-15 theme-fill pa curP mt-10 t-0 r-0 mr-5" /> */}
                                </div>
                                <div className="flex pv-10 ph-20 mb-20 min-ht-250 t-20 mt-30 overflowAuto min-wt-250 max-wt-900 max-ht-700">
                                    {(groups || []).map(transGroup => (
                                        <div className="mr-10 wt-250">
                                            <GroupContainer
                                                group={transGroup}
                                                toggleAllTransporters={this.toggleAllLegTransporters.bind(this, transGroup)}
                                                toggleTransporter={this.toggleTransporter}
                                                selectedTransporters={selectedTransporters || []}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="z-100 box-shadow pl-40 pv-10 pf b-0 col-1 bg-white">
                                <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={this.setTransport}>Save</button>
                                    <button className="b-20 ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 fRight" onClick={() => this.setState({ showTransporters: false, headerDetails: '', selectedTransporters: [] })}>Cancel</button>
                                </div>
                            </Overlay>}
                </ResponsiveTable>
            </div>
        )
    }
}

export default DisposalProduct;
